import { AppEnvironments } from '~/constants';
import { store } from '~/store';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import AppStore from '../stores/AppStore';

const getComposerSource = ({ tabId, emptySlotMode }) => {
  let sourceName = null;
  switch (tabId) {
    case 'queue':
      /* emptyslotmode is true when a user opens the composer from an empty slot,
      which allows us to know the source is queue_list */
      sourceName = emptySlotMode ? 'queue_list' : 'queue';
      break;
    case 'awaitingApproval':
      sourceName = 'awaiting_approval';
      break;
    case 'drafts':
      sourceName = 'drafts';
      break;
    case 'analytics':
      sourceName = 'share_again';
      break;
    default:
      sourceName = tabId;
      break;
  }
  return sourceName;
};

const getSegmentCampaignMetadata = ({
  post = {},
  profile = {},
  composerSource,
}) => ({
  itemType: 'post',
  itemId: post.id || null,
  campaignId: post.campaign_details.id || null,
  campaignName: post.campaign_details.name || null,
  channel: post.profile_service || null,
  channelId: post.profile_id || null,
  channelType: profile.serviceType || null,
  addedFrom: composerSource || null,
  organizationId: post.organization_id || null,
  isSent: !!(post.service_update_id && post.sent_at),
  isDraft: !!post.draft,
});

const getSegmentChannelMetadata = ({ profile, organizationId, page }) => ({
  product: 'publish',
  organizationId:
    organizationId || selectCurrentOrganizationId(store.getState()),
  channelId: profile.id,
  channelServiceId: profile.serviceId,
  channelUsername: profile.service?.username || null,
  channelType: profile.serviceType,
  channel: profile.service.name,
  page: page || null,
});

function getCalendarVersion() {
  const isNewCalendar =
    !!window.location.href.match(
      /publish(?:\.local)?.buffer.com(?::\d{4})?\/calendar/
    ) || false;
  return isNewCalendar ? 'newCalendar' : 'classicCalendar';
}

const getCurrentPage = (tabId, emptySlotMode) => {
  const { appEnvironment } = AppStore.getMetaData();

  if (appEnvironment === AppEnvironments.EXTENSION) return 'extension';
  if (appEnvironment === AppEnvironments.CALENDAR) return getCalendarVersion();
  if (appEnvironment === AppEnvironments.CAMPAIGNS) return 'campaigns';

  return (
    getComposerSource({
      tabId,
      emptySlotMode,
    }) || 'queue'
  );
};

export {
  getComposerSource,
  getSegmentCampaignMetadata,
  getSegmentChannelMetadata,
  getCurrentPage,
};
